const ID = 'spinnerDefault'


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  hide () {
    let targetSpinner = document.getElementById(ID)
    targetSpinner.classList.add('hideSpinner')
  },
  show () {
    let targetSpinner = document.getElementById(ID)
    targetSpinner.classList.remove('hideSpinner')
  }
} 


